import { MutationTree } from 'vuex';
import { DeviceInfo } from '@/common/apis/DeviceApi';
import { IFloorplanViewState, IFloorplanView, IFloorplanButton } from './types';
import Vue from 'vue';
import _ from 'lodash';

export const mutations: MutationTree<IFloorplanViewState> = {
    loaded(state, args: { deviceNumber: string, view: IFloorplanView }) {
        const clonedView = _.cloneDeep(args.view);
        Vue.set(state.devices, args.deviceNumber, clonedView);
    },
    setPosition(state, args: {deviceNumber: string, buttonIndex: number, x: number, y: number }) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            const button = device.buttons[args.buttonIndex];
            if (button) {
                Vue.set(button, 'x', args.x);
                Vue.set(button, 'y', args.y);
            }
        }
    },
    setButton(state, args: {deviceNumber: string, buttonIndex: number, button: IFloorplanButton | null }) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            if (args.button) {
                Vue.set(device.buttons, args.buttonIndex, args.button);
            } else {
                Vue.delete(device.buttons, args.buttonIndex);
            }
        }

    },
    addButton(state, args: {deviceNumber: string }) {
        const device = state.devices[args.deviceNumber];
        if (device && device.buttons) {
            Vue.set(device.buttons, device.buttons.length, {
                type: 'relay',
                icon: 'fa-lightbulb-o',
                relayNumber: '0',
                x: 0.5,
                y: 0.5,
                size: 'medium',
                colorOn: 'Green',
                colorOff: 'Red',
            });
        }
    },
};
